<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZEiADq/tc-custom/9781631957758.jpg?1725275627129" alt="This image is the cover for the book Money Hacks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Money Hacks
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An investing expert reveals the secret strategies of the super-rich for building wealth now and in the future.</b></p><p> Larry Steinhouse’s passion for investing in profitable properties and lucrative stock options—and teaching others how to generate wealth—has motivated him to share <i>Money Hacks</i> with anyone looking to build a more secure and financially profitable future. Steinhouse is known for his unique approach to money—an approach that, on the surface, seems to be in complete opposition to today’s popular financial counselors. And yet, his strategies have proven to be the best-kept secrets of the super-rich that have made many people wealthy and are still making people rich today. </p><p><i>Money Hacks</i> uncovers the mystery of money with Steinhouse’s simple, profitable, and easy-to-follow strategies. Motivated individuals will learn how to buy properties without investing any of their own money and how to obtain huge lines of credit while building up their credit scores and their net worth. Steinhouse also explains how LLCs and trusts can protect one’s wealth from excessive taxation and how to leverage an IRA and/or Roth IRA for huge profits, as well as how the stock market really works. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Larry Steinhouse
      </h2>
      
      <p class="authorDescription body article"><P><B>Larry Steinhouse</B> has been buying and selling houses since he was 18 years old. After losing all his wealth&#8212;including over $3 million in properties&#8212;in the 2008 crash, Larry was determined not to just rebuild his financial security, but to build it differently. He has tirelessly researched the best investment strategies for both current and future financial wealth and how to keep it economy-proof. In 2018, Larry co-founded Investor Schooling with his business partner, Phil Falcone. The school is a brick-and-mortar real estate and stock options investment school located in Newtown, PA, just outside of Philadelphia. The school welcomes investors (both novice and intermediate level investors) to come learn the tricks of the trade. In his free time, Larry enjoys shopping for distinctive blazers that mirror his personality, driving one of his sports cars, and continuing to woo his lovely bride, Linda Steinhouse. He resides in Ivyland, PA.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?04f36760